<radr-modal toolbarColor="primary">
  <ng-container body>
    <div class="spinner-container" *ngIf="isLoading">
      <mat-progress-spinner class="spinner"></mat-progress-spinner>
    </div>
    <div class="qualifier-count-body" *ngIf="qualifier">
      <div class="qualifier-count-header">
        <span class="qualifier-header-field" *ngIf="qualifier.name">{{ qualifier.name }}</span>
        <span class="divider" *ngIf="qualifier.description"> | </span>
        <radr-text-overflow
          class="qualifier-header-field"
          [displayText]="qualifier.description"
          *ngIf="qualifier.description"
        >
        </radr-text-overflow>
        <div *ngIf="qualifier.matchedCount">
          <span class="divider"> | </span>
          <span class="qualifier-header-field">MATCHED HOUSEHOLD COUNT Target:</span>
          <span>{{ qualifier.matchedCount }}</span>
        </div>
      </div>
      <div class="qualifier-count-header">
        <span class="qualifier-header-field">Date Created: </span>
        <span>{{ qualifier.createdDateTime | date: "shortDate" }}</span>
        <span class="qualifier-header-field">Date Updated: </span>
        <span>{{ qualifier.lastModifiedDateTime | date: "shortDate" }}</span>
      </div>

      <ng-container *ngIf="qualifierValueCounts">
        <cdk-virtual-scroll-viewport
          [itemSize]="70"
          [minBufferPx]="70 * 1"
          [maxBufferPx]="70 * 20"
          [ngStyle]="{ 'height.px': qualifierValueCounts?.length < 10 ? (qualifierValueCounts?.length + 1) * 70 : 250 }"
        >
          <div class="table">
            <div class="table-row header">
              <div class="text">
                <span>Qualifier Details</span>
              </div>
              <div class="text">
                <span>Counts</span>
              </div>
            </div>
            <div
              class="table-row content"
              *cdkVirtualFor="let qualifierValueCount of qualifierValueCounts; templateCacheSize: 100"
            >
              <div class="text">
                <span>{{ qualifierValueCount.value }}</span>
              </div>
              <div class="text">
                <span>{{ qualifierValueCount.count }}</span>
              </div>
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      </ng-container>
    </div>
  </ng-container>
  <ng-container actions *ngIf="!!qualifier && !isLoading">
    <div class="add-qualifier-field" *ngIf="qualifier?.status?.id === QualifierStatusEnum.Processed">
      <span class="add-text">Add to New Profile/Profiles:</span>
      <div>
        <radr-select-autocomplete
          [options]="buildSelectAutocompleteOptions()"
          [showActions]="false"
          [control]="qualifierSelection"
          placeholder="Select"
        >
        </radr-select-autocomplete>
        <button
          color="primary"
          [disabled]="!canAddQualifier()"
          mat-flat-button
          (click)="addQualifierToProfiles(qualifierSelection.value)"
        >
          Add
        </button>
      </div>
    </div>
    <button
      *ngIf="qualifier?.status?.id !== QualifierStatusEnum.Processed"
      color="primary"
      mat-flat-button
      (click)="close()"
    >
      Close
    </button>
  </ng-container>
</radr-modal>
